export enum AuthClaims {
    TextKit = "https://textkit.io",
}

export const IDLE_TIMEOUT = 1000 * 60 * 60 * 16;
export const PROMPT_TIMEOUT = 1000 * 30;

export const LOGOUT_URL = `${window.location.origin}/login`;
export const TIMEOUT_URL = `${window.location.origin}/login`;
